import { createContext, PropsWithChildren, useRef } from 'react';
import { CookieStores, createSearchKeywordStore, createUserInfo } from '../stores/cookie';
import { CookieObject } from '@/shared/consts/cookie-key';

//@ts-expect-error server init
// eslint-disable-next-line react-refresh/only-export-components
export const CookieStoreContext = createContext<CookieStores>();

export function CookieProvider(
  props: PropsWithChildren<{
    value: CookieObject;
  }>,
) {
  const { children, value: cookieObject } = props;
  const storeRef = useRef<CookieStores>(null);

  if (!storeRef.current) {
    storeRef.current = {
      searchKeywords: createSearchKeywordStore(cookieObject.searchKeywords),
      accessToken: cookieObject.accessToken,
      refreshToken: cookieObject.refreshToken,
      userInfo: createUserInfo(cookieObject.userInfo),
    };
  }

  return (
    <CookieStoreContext.Provider value={storeRef.current}>{children}</CookieStoreContext.Provider>
  );
}
